import { emptySplitApi } from "./InjectionEndpoint"

const calendarHoursService = emptySplitApi.injectEndpoints({
    endpoints: (build) => ({
        getDatesCalendar: build.query({
            query: (params: any) => `/api/ImpostazioniSede/${params.anno}/${params.mese}`,
            providesTags: ['dates']
        }),

        saveDateDayCalendar: build.mutation<void, any>({
            query: (body) => ({
                url: '/api/ImpostazioniSede',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['dates', 'appointments']
        }),

        getGlobalAppointments: build.query({
            query: () => "/api/ImpostazioniSede/globali",
            providesTags: ['appointments']
        }),

        saveGlobalAppointments: build.mutation<void, any>({
            query: (body) => ({
                url: '/api/ImpostazioniSede/globali',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['appointments']
        }),
    }),
})

export const {
    useGetDatesCalendarQuery,
    useSaveDateDayCalendarMutation,
    useSaveGlobalAppointmentsMutation,
    useGetGlobalAppointmentsQuery
} = calendarHoursService;